module.exports = __webpack_public_path__ + "media/form/formalurios_solicitudes-b5c388e2.png";